import React from 'react';
import { Check } from 'lucide-react';
import { useSpecialties } from '../../lib/useSpecialties';
import { getCategoryName, resolveCategoryId } from '../../lib/categories';

export function SpecialtyPicker({ categories, selected, onChange, testId = 'specialty-picker' }) {
  const data = useSpecialties();
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id]);
  const resolved = categories.map((c) => resolveCategoryId(c) || resolveCategoryId(String(c).toLowerCase()));
  const groups = [...new Set(resolved)].filter((c) => c && data[c]?.length);
  if (!groups.length) return null;

  return (
    <div className="space-y-4" data-testid={testId}>
      {groups.map((cat) => (
        <div key={cat}>
          <p className="text-xs uppercase tracking-[0.15em] text-stone-500 mb-2">{getCategoryName(cat)}</p>
          <div className="flex flex-wrap gap-2">
            {data[cat].map((s) => {
              const on = selected.includes(s.id);
              return (
                <button
                  key={s.id}
                  type="button"
                  onClick={() => toggle(s.id)}
                  className={`inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border transition-colors ${on ? 'bg-[#1A1A1A] text-white border-[#1A1A1A]' : 'bg-white text-stone-600 border-[#E6E4DD] hover:border-[#D4AF37]'}`}
                  data-testid={`specialty-option-${s.id}`}
                  aria-pressed={on}
                >
                  {on && <Check className="h-3 w-3" />}{s.name}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
